
import { updateAppConfig } from '#app'
import { defuFn } from '/Users/shinichi.ishimura/workspace/29.ds/01.chirashi-viewer/chirashi-viewer/node_modules/defu/dist/defu.mjs'

const inlineConfig = {
  "nuxt": {
    "buildId": "52eada89-9318-4996-ac01-942f920e3fcd"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}



export default /* #__PURE__ */ defuFn(inlineConfig)
